import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AOS from "aos";
import "aos/dist/aos.css";
import CoHa from "../../../../assets/images/hachef.png";
import BaTung from "../../../../assets/images/tungchef.png";
import Kaiser from "../../../../assets/images/kaiser.png";
const settings = {
  dots: true,
  lazyLoad: true,
  infinite: true,
  speed: 750,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  focusOnSelect: false,
  responsive: "",
  arrows: true,
  accessibility: true,
};

const photos = [
  {
    name: "Bếp Trưởng Hà",
    photoUrl: CoHa,
    bio:
      "Chinh phục vị giác bằng nấu nướng, Bếp Trưởng Hà đã được vinh danh là một trong những đầu bếp giỏi nhất ở Royal Hotel Sài Gòn. Khi dành được uy tín tại buổi liên hoan bếp trưởng Á Âu 2017, đầu bếp Hà đã suy nghĩ và quyết định mở Bún Bò O Như, xem đây là đứa con tinh thần sau tất cả kinh nghiệm mà bà đã trải qua.",
  },
  {
    name: "Bếp Phó Tùng",
    photoUrl: BaTung,
    bio:
      "Hơn 15 năm kinh nghiệm làm việc với các nhà hàng hải sản, ông may mắn gặp được Bếp Trưởng chung chí hướng và cùng mở Bún Bò O Như. Ngoài ra, Bếp Phó Tùng thích sáng chế các món mới trong thời gian nhàn rỗi như chia sẻ và trau dồi thêm kinh nghiệm nấu ăn của mình.",
  },
  {
    name: "Phụ Bếp Khang",
    photoUrl: Kaiser,
    bio:
      "Sau khi tốt nghiệp đại học, anh chưa hề nghĩ về việc làm bếp. Tuy nhiên, do số phận đưa đẩy, Bếp Trưởng cho anh một chân trong quán Bún Bò O Như và cùng mọi người tạo ra các tô bún tuyệt hảo!",
  },
];

const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});
export default function SlideShow() {
  useEffect(() => {
    AOS.init({});
  }, []);
  const renderSlides = () =>
    photos.map((photo) => (
      <div data-aos="zoom-in" data-aos-duration="2000">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "1rem",
          }}
        >
          <img width="50%" src={photo.photoUrl} alt="bun bo" />
          <span style={{ paddingLeft: "1rem" }}>{photo.bio}</span>
        </div>
        <ThemeProvider theme={serifFont}>
          <Typography variant="h5">{photo.name}</Typography>
        </ThemeProvider>
      </div>
    ));

  return (
    <div className="App">
      <Slider
        // nextArrow={<Arrow type="next" />}
        // prevArrow={<Arrow type="prev" />}
        {...settings}
      >
        {renderSlides()}
      </Slider>
    </div>
  );
}
